export enum UploadType {
  LoanOfficerHeadshotImage = "loan_officer_headshot_image",
  LoanOfficerSignatureImage = "loan_officer_signature_image",
  FinancialReportingDataCSV = "financial_reporting_data_csv",
}

export const UploadTypeDisplayValues: { [key in UploadType]: string } = {
  [UploadType.LoanOfficerHeadshotImage]: "LO headshot image",
  [UploadType.LoanOfficerSignatureImage]: "LO signature image",
  [UploadType.FinancialReportingDataCSV]: "Financial reporting CSV",
};

export enum ContentType {
  Jpeg = "image/jpeg",
  Png = "image/png",
  Csv = "text/csv",
}

export enum UploadField {
  Id = "id",
  UploadType = "upload_type",
  OriginalFilename = "original_filename",
  SizeBytes = "size_bytes",
  ContentType = "content_type",
  S3Key = "s3_key",
  UploaderEntityType = "uploader_entity_type",
  UploaderEntityID = "uploader_entity_id",
  CreatedAt = "created_at",
  UpdatedAt = "updated_at",
  DeletedAt = "deleted_at",
}

export interface Upload {
  [UploadField.Id]: number;
  [UploadField.UploadType]: UploadType;
  [UploadField.OriginalFilename]: string;
  [UploadField.SizeBytes]: number;
  [UploadField.ContentType]: ContentType;
  [UploadField.S3Key]: string;
  [UploadField.UploaderEntityType]: string;
  [UploadField.UploaderEntityID]: number;
  [UploadField.CreatedAt]: number;
  [UploadField.UpdatedAt]: number;
  [UploadField.DeletedAt]: number | null;
}
